import { render, staticRenderFns } from "./ExitCafeList.vue?vue&type=template&id=18c0f0f6&"
import script from "./ExitCafeList.vue?vue&type=script&lang=js&"
export * from "./ExitCafeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports